import Api from '@common/services/api';
import {
  CategoryPayload
} from '../types';

export const updateCategory = async (
  organisationId: string,
  categoryId: string,
  payload: CategoryPayload
) => {
  const result = await Api.put(
    `/v1/organisations/${organisationId}/performance/competency/categories/${categoryId}`,
    payload
  );

  return { data: result.data };
};
